<template>
    <tr class="border-b-[1px] border-[#FFF] border-opacity-10">
        <td class="px-3 py-2 text-start text-sm">
            <span class="text-[#FFF] font-medium">{{ file.file_name }}</span>
        </td>
        <td class="px-3 py-2 text-start text-sm truncate max-w-[200px] text-gray-400" :title="file.s3_key">
            {{ file.s3_key }}
        </td>
        <td class="px-3 py-2 text-start text-sm truncate max-w-[250px] text-[#FFF]">
            {{ file.description || '—' }}
        </td>
        <td class="px-3 py-2 text-start text-sm text-gray-400">
            {{ formatDate(file.uploaded_at) }}
        </td>
        <td class="px-3 py-2 text-end text-sm">
            <button
                class="px-2 py-1 rounded-[10px] text-sm font-medium"
                title="Редагувати опис"
                @click="$emit('edit', file)"
            >
                <img src="@/assets/icons/pen_icon.svg" class="w-6 h-6">
            </button>
            <button
                class="px-2 py-1 rounded-[10px] text-sm font-medium text-red-600"
                title="Видалити"
                @click="$emit('delete', file)"
            >
                <img src="@/assets/icons/trash_icon.svg" class="w-6 h-6">
            </button>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'file-row',

        props: {
            file: {
                type: Object,
                required: true
            }
        },

        setup() {
            const formatDate = (dateStr) => {
                if (!dateStr) return '—'
                const d = new Date(dateStr)
                return d.toLocaleDateString('uk-UA', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                })
            }

            return { formatDate }
        }
    }
</script>
